import { PimsterUIProvider } from '@hello-pimster/pimster-ui';
import type { AnalyticsEvent } from '@hello-pimster/pimster-ui';
import { useAnalytics } from '@lib/analytics/analyticsContext';
import { getLocaleDirection } from '@utils/locale/direction';
import { useRouter } from 'next/router';
import { type PropsWithChildren, useCallback } from 'react';

import { mapPimsterUIEvent } from '../analytics/eventMapper';
import { usePimsterUITranslations } from '../translations/usePimsterUITranslations';

export const PimsterUIBridge = ({ children }: PropsWithChildren) => {
    const router = useRouter();
    const { track } = useAnalytics();
    const translations = usePimsterUITranslations();

    const onEvent = useCallback(
        (event: AnalyticsEvent) => mapPimsterUIEvent(event, track),
        [track]
    );

    return (
        <PimsterUIProvider
            dir={getLocaleDirection(router.locale)}
            onEvent={onEvent}
            translations={translations}
        >
            {children}
        </PimsterUIProvider>
    );
};
